/**
 * Skeleton do prontuário de atendimento — layout full-height com a
 * sidebar "Agenda hoje" à esquerda e a área principal do atendimento.
 */
export default function Loading() {
  return (
    <div className="flex min-h-[calc(100vh-3.5rem)] animate-pulse">
      {/* Sidebar da agenda do dia */}
      <aside className="hidden w-[180px] shrink-0 border-r border-slate-200 bg-slate-50 p-2 md:flex md:flex-col md:gap-1.5">
        <div className="mx-1 mb-2 h-3 w-20 rounded bg-slate-200" />
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="h-12 rounded-md border border-slate-200 bg-white" />
        ))}
      </aside>

      {/* Área principal do atendimento */}
      <div className="flex-1 p-4 sm:p-6">
        {/* Cabeçalho do paciente */}
        <div className="flex items-center gap-4">
          <div className="h-12 w-12 shrink-0 rounded-full bg-slate-200" />
          <div className="flex-1">
            <div className="h-5 w-64 rounded bg-slate-200" />
            <div className="mt-2 h-3 w-40 rounded bg-slate-100" />
          </div>
          <div className="hidden h-10 w-36 rounded-lg bg-slate-200 sm:block" />
        </div>

        {/* Blocos do prontuário (SOAP / histórico / documentos) */}
        <div className="mt-6 grid gap-4 lg:grid-cols-[1fr_320px]">
          <div className="flex flex-col gap-4">
            <div className="h-48 rounded-xl border border-slate-200 bg-white" />
            <div className="h-32 rounded-xl border border-slate-200 bg-white" />
          </div>
          <div className="flex flex-col gap-4">
            <div className="h-40 rounded-xl border border-slate-200 bg-white" />
            <div className="h-40 rounded-xl border border-slate-200 bg-white" />
          </div>
        </div>
      </div>
    </div>
  );
}
